export default url => {
  return url && /^https?/.test(String(url))
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/isAbsoluteUrl.js